import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
		<path
			fill='#ee2b7b'
			d='M18.3 21H5.7A2.589 2.589 0 0 1 3 18.545V7.091a2.589 2.589 0 0 1 2.7-2.455h.9v-.818A.863.863 0 0 1 7.5 3a.863.863 0 0 1 .9.818v.818h7.2v-.818a.9.9 0 0 1 1.8 0v.818h.9A2.589 2.589 0 0 1 21 7.091v11.454A2.589 2.589 0 0 1 18.3 21Zm-1.8-4.909a.822.822 0 1 0 .9.818.863.863 0 0 0-.9-.818Zm-4.5 0a.822.822 0 1 0 .9.818.863.863 0 0 0-.9-.818Zm-4.5 0a.822.822 0 1 0 0 1.636.822.822 0 1 0 0-1.636Zm9-3.273a.822.822 0 1 0 .9.818.863.863 0 0 0-.9-.818Zm-4.5 0a.822.822 0 1 0 .9.818.863.863 0 0 0-.9-.818Zm-4.5 0a.822.822 0 1 0 0 1.636c.491 0 .9-.81.9-.818s-.4-.818-.9-.818ZM5.7 6.273a.863.863 0 0 0-.9.818v2.454h14.4V7.091a.863.863 0 0 0-.9-.818h-.9v.818a.9.9 0 0 1-1.8 0v-.818H8.4v.818a.863.863 0 0 1-.9.818.863.863 0 0 1-.9-.818v-.818Z'
			data-name='Sustracci\xF3n 7'
		/>
		<path fill='none' d='M0 0h24v24H0z' data-name='Rect\xE1ngulo 85588' />
	</svg>
)
export default SvgComponent
